var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87119 10.2775C2.47119 11 3.58719 11 5.82019 11H6.18019C8.41319 11 9.52969 11 10.1297 10.2775M1.87119 10.2775C1.27119 9.5545 1.47719 8.4575 1.88869 6.2625C2.18119 4.7025 2.32719 3.922 2.88269 3.461M10.1297 10.2775C10.7297 9.5545 10.5237 8.4575 10.1122 6.2625C9.81969 4.7025 9.67319 3.922 9.11769 3.461M9.11769 3.461C8.56269 3 7.76819 3 6.18069 3H5.81969C4.23219 3 3.43819 3 2.88269 3.461",
    stroke: "#FCFAFA",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.5L8 8.5M4.5 5.5L4 8.5M4.5 3V2.5C4.5 2.10218 4.65804 1.72064 4.93934 1.43934C5.22064 1.15804 5.60218 1 6 1C6.39782 1 6.77936 1.15804 7.06066 1.43934C7.34196 1.72064 7.5 2.10218 7.5 2.5V3",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBagIcon);
export default __webpack_public_path__ + "static/media/white_Bag_Icon.0baa10845a41d3c94e6e4eb952a76ace.svg";
export { ForwardRef as ReactComponent };